export default __webpack_public_path__ + "static/media/icon-shopping-active.62fcf80c.svg";